<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 col-md-12 offset-lg-2 main-body">
                <div class="row">
<!--                    <div class="col-lg-4 col-md-12">-->
<!--                        <div class="dash-block">-->
<!--                            <a href="#">-->
<!--                                <div class="dash-inner-block text-center">-->
<!--                                    <i class="icon ion-md-contact"></i>-->
<!--                                    <h5 class="text-center">Parishioner Info.</h5>-->
<!--                                </div>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-lg-4 col-md-12">
                        <div class="dash-block">
                            <router-link :to="{name:'FamilyMembers'}">
                                <div class="dash-inner-block text-center">
                                    <i class="icon ion-md-contacts"></i>
                                    <h5 class="text-center">Family Members</h5>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <div class="dash-block">
                            <router-link :to="{name:'EditParishioner'}">
                                <div class="dash-inner-block text-center">
                                    <i class="icon ion-md-settings"></i>
                                    <h5 class="text-center">Update Info.</h5>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {firestoreDB} from '../../config/firebase'

    const parishioners = firestoreDB.collection("parishioners");

    export default {
        name: "DashHome",
        mounted(){
            let tmpID = sessionStorage.getItem('dashboardID');
            if(tmpID){
                parishioners.doc(tmpID).get().then((doc) => {
                    if(!doc.exists){
                        this.$router.replace({name:'Login'})
                    }
                });
            }else{
                this.$router.replace({name:'Login'})
            }


        }
    }
</script>

<style scoped>
    .main-body{
        min-height: 600px;
        background:rgb(250,250,250);
        padding-top:10px
    }
    .dash-block{
        padding:10px;
    }
    .dash-block > a:hover .dash-inner-block h5, .dash-block > a:hover .dash-inner-block i{
        color: #E12993!important;
    }
    .dash-inner-block{
        background-color: #439EF3;
        height:170px
    }
    .dash-inner-block > i{
        font-size: 48px;
        color: #ffffff;
    }
    .dash-inner-block h5{
        color: #ffffff;
        margin-top:30px
    }
</style>